// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'

const unsync = sync(store, router)

Vue.use(VueResource)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  destroyed () {
    unsync()
  }
})



// WEBPACK FOOTER //
// ./client/main.js